module.exports = __webpack_public_path__ + "img/buetti-cvp.d849fe33.jpg";